// src/components/LoginLayout.js
import React from 'react';

const LoginLayout = ({ children }) => {
  return (
    <div className="row g-0 loginScreen">
      <div className="col-12 d-flex align-items-center justify-content-center flex-column">
        {children}
      </div>
    </div>
  );
};

export default LoginLayout;
